import {
  TSetStateAction,
  TErrorFormat,
  TSetFieldError,
} from '@skillarea/lib-shared';

import { distributeErrors } from './distributeErrors';

export function handleErrorsAndTimer(
  result: { dtoMessages?: TErrorFormat[]; message?: string; timer?: number },
  setFieldError?: TSetFieldError,
  setModal?: (v: string) => void,
  setTimer?: (v: TSetStateAction<Date | null>) => void,
) {
  if (result?.dtoMessages && setFieldError)
    distributeErrors(setFieldError, result.dtoMessages);

  if (result.message) setModal?.(result.message);

  if (result.timer) setTimer?.(new Date(Date.now() + result.timer));
}
